import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription, forkJoin } from 'rxjs';

// メニュー項目の型定義
interface NoteMenuItem {
    title: string;
    path: string;
    icon: string;
    lastUpdated: Date | null;
}

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    user: any = null;
    isHandset: boolean = false;
    private breakpointSubscription: Subscription | undefined;

    // サイドバーに表示する動的メニューリスト
    noteMenuItems: NoteMenuItem[] = [];

    @ViewChild('drawer') drawer!: MatSidenav;

    constructor(
        private authService: AuthService,
        private router: Router,
        private breakpointObserver: BreakpointObserver
    ) { }

    ngOnInit(): void {
        // ユーザー情報の取得
        this.authService.fetchCurrentUser().subscribe({
            next: (data) => {
                this.user = data;
            },
            error: (err) => {
                console.error('User fetch failed', err);
                this.router.navigate(['/login']);
            }
        });

        // 画面サイズ監視（モバイルかどうか）
        this.breakpointSubscription = this.breakpointObserver.observe(Breakpoints.Handset)
            .subscribe(result => {
                this.isHandset = result.matches;
            });

        // メニューデータのロード
        this.loadNoteMenuData();
    }

    /**
     * サイドバーのメニューデータを構築し、APIから最新の日付を取得する
     */
    loadNoteMenuData(): void {
        // 1. まずメニューの枠組みを作る（日付はnullで初期化）
        this.noteMenuItems = [
            {
                title: 'チームメモ', // 名称変更
                path: '/notes/project',
                icon: 'description',
                lastUpdated: null
            },
            {
                title: '菅原メモ',   // 名称変更
                path: '/notes/minutes',
                icon: 'event_note',
                lastUpdated: null
            }
        ];

        // 2. APIからデータを並列で取得して日付を更新
        // team: チームメモ用, sugawara: 菅原メモ用
        forkJoin({
            team: this.authService.getMemo('team'),
            sugawara: this.authService.getMemo('sugawara')
        }).subscribe({
            next: (res: any) => {
                // チームメモの日付更新
                if (res.team && res.team.updated_at) {
                    this.noteMenuItems[0].lastUpdated = new Date(res.team.updated_at);
                }
                // 菅原メモの日付更新
                if (res.sugawara && res.sugawara.updated_at) {
                    this.noteMenuItems[1].lastUpdated = new Date(res.sugawara.updated_at);
                }
            },
            error: (err) => {
                console.error('Failed to load menu dates', err);
                // エラー時は日付なしのまま表示される
            }
        });
    }

    ngOnDestroy(): void {
        // メモリリーク防止のため購読解除
        if (this.breakpointSubscription) {
            this.breakpointSubscription.unsubscribe();
        }
    }

    onLogout(): void {
        this.authService.logout().subscribe({
            next: () => {
                window.location.href = '/login';
            },
            error: () => {
                window.location.href = '/login';
            }
        });
    }
}